<strong>
  <div class="flex row y-items-end full-width">
    <div class="flex">
      <small class="inline-block uppercase">
        <ng-container *ngIf="currency == 'MXN'">
          mxn
        </ng-container>
        <ng-container *ngIf="currency == 'USD'">
          us
        </ng-container>
        <ng-container *ngIf="currency == 'BRL'">
          r
        </ng-container>
        <ng-container *ngIf="currency == 'AUD'">
          $
        </ng-container>
        <ng-container *ngIf="currency == 'PLN'">
          z
        </ng-container>
      </small>
      <span class="inline-block margin-right-5">
        <ng-container *ngIf="currency == 'USD' || currency == 'CAD' || currency == 'BRL' || currency == 'MXN'">$</ng-container>
        <ng-container *ngIf="currency == 'EUR'">&euro;</ng-container>
        <ng-container *ngIf="currency == 'GBP'">&pound;</ng-container>
        <ng-container *ngIf="currency == 'AUD'">A</ng-container>
        <ng-container *ngIf="currency == 'PLN'">ł</ng-container>
      </span>
      <strong class="jackpot-price margin-right-15 margin-left-10 relative">{{jackpot < 1 ? '' : jackpot}}</strong>
    </div>
    <div class="flex column x-items-end">
      <div class="jackpot-countdown margin-bottom-10">
        <app-countdown></app-countdown>
      </div>
      <small class="jackpot-millions inline-block margin-left-5">
        <ng-container *ngIf="('lang' | translate) == 'en'">{{jackpot < 1 ? 'Pending' : "Million"}}</ng-container>
        <ng-container *ngIf="('lang' | translate) == 'es'">{{jackpot < 1 ? 'Pendiente' : "Millones"}}</ng-container>
        <ng-container *ngIf="('lang' | translate) == 'pt'">{{jackpot < 1 ? 'Pendente' :"MILHÕES"}}</ng-container>
      </small>
    </div>
  </div>
</strong>
